// @flow

import * as React from "react";
import { ReactForm } from "@adrenalin/react-form";

import useMergableState from "../../hooks/useMergableState";

import SharedFilterFunctions from "./SharedFilterFunctions";

type PropsType = {
    data: any,
    resetUrl: string,
};

const { useEffect } = React;

const SearchFilters = (props: PropsType): React.Node => {
    // Pull out data from props
    const { type: contentTypes } = props.data;

    // State vars
    const [inputState, setInputState] = useMergableState({});

    // Search param
    const searchFieldName =
        window.globalData.search.page.parameter || "keyword";

    // Watch the master 'keyword' input and save its input so that we can clone it
    // into this filter form. This let's us keep track of the searched for query when
    // the user submits the filter form without the input physically being inside
    // this form.
    useEffect((): any => {
        const keywordInputMaster = document.querySelector(
            ".search-standalone__content .quicksearch__input"
        );
        const syncInput = () => {
            if (keywordInputMaster instanceof HTMLInputElement) {
                setInputState({
                    [searchFieldName]: keywordInputMaster.value,
                });
            }
        };
        syncInput();
        if (keywordInputMaster instanceof HTMLInputElement) {
            keywordInputMaster.addEventListener("change", syncInput);
        }
        return () => {
            if (keywordInputMaster) {
                keywordInputMaster.removeEventListener("change", syncInput);
            }
        };
    }, []);

    const {
        renderFilterActions,
        filterGroupLooper,
        createFilterGroup,
    } = new SharedFilterFunctions(inputState, setInputState, "Search Filters");

    const filterGroups = [
        createFilterGroup("checkbox", "Content Type", contentTypes),
    ];

    // Render
    return (
        <div className="filters__outer">
            <ReactForm pageSubmit disableErrorScroll>
                <div className="filters__inner">
                    <div className="filters__inputs">
                        {/* Clone the quicksearch input to make sure the search query there is submitted with the form */}
                        <input
                            type="text"
                            name={searchFieldName}
                            value={inputState.keyword}
                            hidden
                        />
                        <div className="filters__accordions search-accordions">
                            {filterGroupLooper(filterGroups)}
                        </div>
                    </div>
                    {renderFilterActions(props.resetUrl)}
                </div>
            </ReactForm>
        </div>
    );
};

export default SearchFilters;
